import { createReducer, on } from '@ngrx/store';
import * as TechnicianActions from './technician.actions';

export const technicianFeatureKey = 'technician';

export interface TechnicianState {
  technicians: Array<{ id: number; name: string }>;
  loading: boolean;
  error: string | null;
}

export const initialState: TechnicianState = {
  technicians: [],
  loading: false,
  error: null,
};

export const technicianReducer = createReducer(
  initialState,
  on(TechnicianActions.loadTechnicians, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(TechnicianActions.loadTechniciansSuccess, (state, { technicians }) => ({
    ...state,
    technicians,
    loading: false,
    error: null,
  })),
  on(TechnicianActions.loadTechniciansFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
